export class TextAlign {
    static text_align_right: string = 'right';
    static text_align_left: string = 'left';
    static text_align_center: string = 'center';
}